<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";   
import apigeneric from "@/helpers/apigeneric";
import Loader from "@/components/widgets/loader";
import Banner from "../components/banner";

export default {
  page: {
    title: process.env.VUE_APP_NAME,
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Loader,
    Banner

  },
  mixins: [ apigeneric],
  data() {
    return {
      title: this.$t('StrAnasayfa.Title'),
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      NoticesData:{},
      NoticesTitle: {},
      NoticesTitleDescription: {},
      ReadMoreValue: {},
      LangId: this.$route.params.LangId,
      items: [
         
        {
          text: this.$t('StrAnasayfa.Title'),
          active: true,
        },
      ],  
      fetchingStats: true,  
    };
  }, 
  methods: { 
    Get(){
        
      if(this.LangId=="tr" || this.LangId== null){
        this.ActionsFilterGet({
        Service: "News",
        Page: this.Page,
        Filter:
       "&Newstype=1&Websiteid="+window.$cookies.get("ecampuswebsite"),
      }).then((res) => {
        this.NoticesData = res.Data; 
          this.Page.PageDataSize = res.TotalCount;
      });
    }else{
      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
       "&shortlangtitle="+this.LangId
      }).then((res) => {
        for( let LangData in res.Data){
          this.ActionsFilterGet({
        Service: "newstranslations",
        Page: this.Page,
        Filter: "&Langid="+ res.Data[LangData].Id
      }).then((res) => {
        this.NoticesData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        if(res.TotalCount == 0){
              localStorage.setItem("lang", "tr");
              window.location.reload();
              
            }
        
      });
         }
        
      });
     
    }
    this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=215b4e3e-250f-4ebd-bf96-f04aec90de20"
          }).then((res) => {
            this.NoticesTitle = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });

      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=19269e1f-b2fe-4ea9-9a2b-4c5cd91d2266"
          }).then((res) => {
            this.NoticesTitleDescription = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });

      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=878b315b-fa05-41b1-9cc5-4c480effbf65"
          }).then((res) => {
            this.ReadMoreValue = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });
    }
  },
};
</script>

<template>
 <Loader>
  <Layout> 
      <Banner />
     
<section>
        <div class="notices">
            <div class="title c-flex flex-column">
                <h3>{{NoticesTitle[0].Resourcevalue}}</h3>
                <p>{{NoticesTitleDescription[0].Resourcevalue}}</p>
            </div> 
            <div class="container">
                <div class="row">
                   
                        <div class="col-md-6 mb-5"  v-for="Data in NoticesData" :key="Data.Id">
                          <div class="notice-item">
                            <div class="row">
                                <div class="col-md-5 ">
                                    <img :src="$config.FILES_URL + 'web/' + Data.Imagegallery" alt="" />
                                </div>
                                <div class="col-md-7 d-flex justify-content-between flex-column">
                                    <p class="head">{{Data.Title}}</p>
                                    <p class="date">{{Data.Startdate | formatDateTime }}</p>
                                    <p class="content">
                                         <span v-html="Data.Description"></span><br />
                                    </p>
                                    <a :href="'/NewsDetail/'+ LangId + '/' + Data.Title.toLowerCase()
                                    .replace(/I|İ/gi, 'i')
                                    .replace(/Ğ|ğ/gi, 'g')
                                    .replace(/Ç|ç|ğ/gi, 'c')
                                    .replace(/\s+/g, '-')
                                    .replace(/&/g, `-and-`)
                                    .replace(/--/g, `-`) + '/'
                 + Data.Id" class="read-more">{{ReadMoreValue[0].Resourcevalue}} &#8594;</a>
                                </div>
                            </div>
                          </div>
                    </div>                  
                </div>
            </div>
                    <b-pagination
                class="pagination pagination-rounded justify-content-end mb-2"
                v-model="DefaultPage"
                :total-rows="Page.PageDataSize"
                :per-page="Page.PageSize"
                aria-controls="my-table"
                @input="ChangePage(DefaultPage)"
              >
              </b-pagination>
        </div>
    </section>



     
  
  </Layout>
  </Loader>
</template>
